import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { AuthService } from '@app/shared/auth/auth.service';

@Injectable()
export class LoggedInGuard implements CanActivate {
  constructor(private router: Router, private authService: AuthService) {
  }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    if (route.queryParams.token) {
      return true;
    }
    if (this.authService.isAuthenticated) {
      this.router.navigate(['home']);
      return false;
    }
    return true;
  }
}
